import { render, staticRenderFns } from "./userDashboardTrainingPlans.vue?vue&type=template&id=33af66f8&scoped=true"
import script from "./userDashboardTrainingPlans.vue?vue&type=script&lang=js"
export * from "./userDashboardTrainingPlans.vue?vue&type=script&lang=js"
import style0 from "./userDashboardTrainingPlans.vue?vue&type=style&index=0&id=33af66f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33af66f8",
  null
  
)

export default component.exports